import CustomTablePagination from 'Components/CustomTablePagination'
import EnhancedTableHead from 'Components/EnhancedTableHead'
import type { HeadCell } from 'Components/EnhancedTableHead/EnhancedTableHead'
import { WithLoader } from 'Components/WithLoader'
import type {
  TicketParamShape,
  TicketShape
} from 'Services/SalesManagement/Features/AffiliateProduct/affiliateProductSlice'
import { TicketListRow } from 'Services/SalesManagement/Features/AffiliateProduct/Components/TicketListRow'
import { ROWS_PER_PAGE_DEFAULT } from 'Util/constants'
import Paper from '@mui/material/Paper'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableContainer from '@mui/material/TableContainer'
import type { FC } from 'react'
import { t } from 'ttag'

const TicketList: FC<{
  rows: TicketShape[]
  loading: string
  params: TicketParamShape
  handleRequestSort: (event: React.MouseEvent<unknown>, property: string) => void
  handleChangePage: (event: unknown, newPage: number) => void
  count: number
}> = ({ rows, loading, params, handleRequestSort, handleChangePage, count }) => {
  const headCells: HeadCell[] = [
    {
      id: 'external_id',
      numeric: false,
      disablePadding: false,
      label: t`External ID`,
      sortable: false
    },
    {
      id: 'product_name',
      numeric: false,
      disablePadding: false,
      label: t`Product`,
      sortable: true
    },
    {
      id: 'ticket_id',
      numeric: false,
      disablePadding: false,
      label: t`Ticket ID`,
      sortable: false
    },
    {
      id: 'payment_method',
      numeric: false,
      disablePadding: false,
      label: t`Payment method`,
      sortable: false
    },
    {
      id: 'external_creation_date',
      numeric: false,
      disablePadding: false,
      label: t`Created`,
      sortable: true
    },
    {
      id: 'waltti_id',
      numeric: false,
      disablePadding: false,
      label: t`Waltti ID`,
      sortable: false
    }
  ]

  return (
    <WithLoader loading={loading === 'pending'} rows={ROWS_PER_PAGE_DEFAULT} height={33}>
      <Paper sx={{ width: '100%', mb: 2 }}>
        <TableContainer>
          <Table sx={{ minWidth: 750 }} aria-labelledby="tableTitle" size="small">
            <EnhancedTableHead
              orderBy={params.ordering}
              headCells={headCells}
              onRequestSort={handleRequestSort}
            />
            <TableBody>
              {rows.map(row => (
                <TicketListRow key={row.id} row={row} />
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <CustomTablePagination
          count={count}
          page={params.page - 1}
          onPageChange={handleChangePage}
        />
      </Paper>
    </WithLoader>
  )
}

export { TicketList }
